<kendo-combobox #kendo_combo_accounts
                [data]="_accountsFiltered"
                [filterable]="true"
                (filterChange)="_handleAccountsFilter($event)"
                [suggest]="true"
                [placeholder]="placeholder"
                [ngModel]="_value"
                (valueChange)="_onValueChange($event)"
                [textField]="'name'"
                [valueField]="'id'"
                [class]="class"
                [disabled]="isDisabled || disabled"
                [required]="required">
</kendo-combobox>
